import React from 'react';
import PropTypes from 'prop-types';
import ScrollBar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

const CustomScrollBar = ({
    style = {},
    children,
    scrollBarRef,
}) => (
    <ScrollBar
        style={style}
        ref={(ref) => { scrollBarRef.current = ref; }}
    >
        {children}
    </ScrollBar>
);

CustomScrollBar.propTypes = {
    style: PropTypes.object,
    children: PropTypes.any,
};

export default CustomScrollBar;
